"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupedProducts = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _components = require("./components");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const GroupedProducts = ({
  groupedProducts,
  currentProductCode,
  getLinkHref,
  onProductClick,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isActive = (0, _react.useCallback)(productCode => productCode === currentProductCode, [currentProductCode]);
  if (groupedProducts.length < 2) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.GROUPED_PRODUCTS),
    className: className,
    children: groupedProducts.map(groupedProduct => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.GroupedProduct, {
      groupedProduct: groupedProduct,
      isActive: isActive(groupedProduct.productCode),
      getLinkHref: getLinkHref,
      onProductClick: onProductClick
    }, groupedProduct.productCode))
  });
};
exports.GroupedProducts = GroupedProducts;
